// From the pure schema entry of platform: this file is bundled into the web app through ./schema.
import { definePermissions } from '@mkcore/platform/schema';

/** Permissions of engagements, rates, budgets and work settings (D04, D08). Object scope: grants per organisation or engagement. */
export const engagementPermissions = definePermissions('engagements', {
  read: 'View engagements, rates, budgets and goals',
  create: 'Add engagements and rates',
  update: 'Change engagements, rates, budgets and goals; archive and restore',
  delete: 'Delete rates that were added by mistake',
  export: 'Export engagements and rates',
  approve: 'Approve the closeout report of an engagement (CO-1321)',
});
